var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundQuestionAsync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_337_6810)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.39674,
    y: 26.5899,
    width: 631.018,
    height: 631.018,
    transform: "rotate(37.506 -2.39674 26.5899)",
    fill: "white",
    stroke: "#00D084",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.95 607.839C1403.49 562.16 1475.89 586.088 1475.6 642.758L1474.57 847.521C1474.43 874.164 1491.47 897.864 1516.77 906.225L1711.19 970.483C1765 988.266 1764.61 1064.51 1710.63 1081.75L1515.57 1144.05C1490.19 1152.15 1472.91 1175.68 1472.78 1202.32L1471.74 1407.09C1471.46 1463.76 1398.82 1486.95 1365.74 1440.94L1246.22 1274.67C1230.67 1253.04 1202.96 1243.88 1177.58 1251.98L982.517 1314.28C928.532 1331.52 884.026 1269.6 917.567 1223.93L1038.76 1058.88C1054.53 1037.4 1054.68 1008.21 1039.12 986.58L919.603 820.316C886.525 774.301 931.654 712.841 985.461 730.625L1179.88 794.883C1205.18 803.244 1232.99 794.364 1248.75 772.889L1369.95 607.839Z",
    fill: "white",
    stroke: "#00D084",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1341.5,
    cy: -118.5,
    r: 305.5,
    fill: "white",
    stroke: "#00D084",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_337_6810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundQuestionAsync);
export default __webpack_public_path__ + "static/media/background_question_async.f0a3a3325dc8ceaa745c7999b8f32d23.svg";
export { ForwardRef as ReactComponent };